"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const storeEvent_1 = require("../lib/storeEvent");
const pick = require("lodash/pick");
class EnviStore {
    constructor(config) {
        // console.log(JSON.stringify(config.statInfo, null, 4))
        this.statInfo = config.statInfo;
        mobx_1.reaction(() => this.newsInfo, (newsInfo) => {
            storeEvent_1.default.sendEvent('enviStore:newsInfo', {
                data: this.newsInfo,
            });
        });
        this.newsInfo = config.newsInfo;
    }
    onNewsInfoChange(handler) {
        storeEvent_1.default.addEventHandler('enviStore:newsInfo', (event) => {
            handler(event.data);
        });
    }
    pick(objKey, keys) {
        if (this[objKey]) {
            return pick(this[objKey], keys);
        }
        return {};
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Object)
], EnviStore.prototype, "newsInfo", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Object)
], EnviStore.prototype, "statInfo", void 0);
exports.default = EnviStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52aVN0b3JlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZW52aVN0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLCtCQUE0QztBQUM1QyxrREFBMkM7QUFDM0Msb0NBQXFDO0FBTXJDLE1BQXFCLFNBQVM7SUFLMUIsWUFBWSxNQUFrQjtRQUMxQix3REFBd0Q7UUFDeEQsSUFBSSxDQUFDLFFBQVEsR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDO1FBQ2hDLGVBQVEsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUMsUUFBUSxFQUFFLEVBQUU7WUFDdkMsb0JBQVUsQ0FBQyxTQUFTLENBQUMsb0JBQW9CLEVBQUU7Z0JBQ3ZDLElBQUksRUFBRSxJQUFJLENBQUMsUUFBUTthQUN0QixDQUFDLENBQUM7UUFDUCxDQUFDLENBQUMsQ0FBQztRQUNILElBQUksQ0FBQyxRQUFRLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQztJQUNwQyxDQUFDO0lBRU0sZ0JBQWdCLENBQUMsT0FBMkI7UUFDL0Msb0JBQVUsQ0FBQyxlQUFlLENBQUMsb0JBQW9CLEVBQUUsQ0FBQyxLQUFLLEVBQUUsRUFBRTtZQUN2RCxPQUFPLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3hCLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVNLElBQUksQ0FBVSxNQUErQixFQUFFLElBQWM7UUFDaEUsSUFBSSxJQUFJLENBQUMsTUFBTSxDQUFDLEVBQUU7WUFDZCxPQUFPLElBQUksQ0FBSSxJQUFJLENBQUMsTUFBTSxDQUFNLEVBQUUsSUFBSSxDQUFDLENBQUM7U0FDM0M7UUFDRCxPQUFPLEVBQUUsQ0FBQztJQUNkLENBQUM7Q0FFSjtBQTNCZTtJQUFYLGlCQUFVOzsyQ0FBNEI7QUFDM0I7SUFBWCxpQkFBVTs7MkNBQXFDO0FBSHBELDRCQTZCQyJ9